import { Injectable } from '@angular/core';
import { ScriptStore, QueryParams, Attribute } from '../../shared/scripts';

declare var document: any;
@Injectable()
export class ScriptLoadService {
  private scripts: any = {};
  private queryString: string;
  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

      /**
     * Loads the script needed, to the head of the document.
     *
     * @param script          Name of the script given in the scripts.ts file
     * @param queryParams     Query Parameter Array of Objects that needs to be appended to the src in scripts.ts
     * @param attribute       Attributes that need to be passed to the setAttribute function of the script being loaded.
     * @param id              Unique ID if needed for the script that is being loaded.
     * @returns               void
     */
    load(script: string, queryParams?: QueryParams[], attribute?: Attribute[],  id?: string) {
      return this.loadScript(script, queryParams, attribute, id);
    }

      /**
     * Loads all the scripts needed, to the head of the document.
     *
     * @param scripts       Names of the scripts given in the scripts.ts file
     * @returns             void
     */
    loadAllScripts(scripts: string[]) {
      const promises: any[] = [];
      scripts.forEach((script) => promises.push(this.load(script)));
      return Promise.all(promises);
    }

    private queryBuilder(queryParam: any) {
      const str = queryParam.name + '=' + queryParam.value;
      return str;
    }

    private loadScript(name: string, queryParams?: QueryParams[], attributes?: Attribute[], id?: string) {
      return new Promise((resolve, reject) => {
        // resolve if already loaded
        if (this.scripts[name].loaded) {
          resolve({script: name, loaded: true, status: 'Already Loaded'});
        } else {
          // load script
          const script = document.createElement('script');
          script.type = 'text/javascript';
          if (queryParams && queryParams.length > 0) {
            queryParams.forEach((queryParam) => {
              const query = this.queryBuilder(queryParam);
              if (this.queryString && this.queryString.length > 0) {
                this.queryString = this.queryString + '&' + query;
              } else {
                this.queryString = query;
              }
            });
            script.src = this.scripts[name].src + '?' + this.queryString;
          } else {
            script.src = this.scripts[name].src;
          }
          if (id && id.length > 0) {
            script.id = id;
          }
          if (attributes && attributes.length > 0) {
            attributes.forEach((attribute) =>
            script.setAttribute(attribute.name, attribute.value));
          }
          if (script.readyState) {  // IE
            script.onreadystatechange = () => {
              if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                this.scripts[name].loaded = true;
                resolve({script: name, loaded: true, status: 'Loaded'});
              }
            };
          } else {  // Others
            script.onload = () => {
              this.scripts[name].loaded = true;
              resolve({script: name, loaded: true, status: 'Loaded'});
            };
          }
          script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
          document.getElementsByTagName('head')[0].appendChild(script);
        }
      });
    }
  }



// WEBPACK FOOTER //
// ../UI/src/app/core/script-load/script-load.service.ts